"use client"

import { ChevronDown } from "lucide-react"
import { useState } from "react"

import { cn } from "@/lib/utils"

export function LandingFaq({ items }: { items: ReadonlyArray<{ q: string; a: string }> }) {
  const [openIdx, setOpenIdx] = useState(0)

  return (
    <div className="flex flex-col">
      {items.map((item, i) => {
        const open = openIdx === i

        return (
          <div key={item.q} className="border-b border-stone-200">
            <button
              type="button"
              onClick={() => setOpenIdx(open ? -1 : i)}
              aria-expanded={open}
              className="flex w-full cursor-pointer items-center gap-4 border-none bg-transparent px-1 py-5 text-left font-sans"
            >
              <span className="flex-1 text-lg font-semibold tracking-[-0.02em] text-stone-800">{item.q}</span>
              <ChevronDown
                className={cn(
                  "size-[18px] shrink-0 text-stone-500 transition-transform duration-[220ms] ease-[cubic-bezier(0.22,1,0.36,1)]",
                  open && "rotate-180"
                )}
                strokeWidth={1.75}
                aria-hidden
              />
            </button>
            {open ? (
              <p className="m-0 max-w-[60ch] px-1 pb-[22px] text-[15px] leading-[1.65] text-pretty text-stone-600">
                {item.a}
              </p>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
